import { render } from "./TressProductTileTag.vue?vue&type=template&id=f7d0745e"
const script = {}

import "./TressProductTileTag.vue?vue&type=style&index=0&id=f7d0745e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__